export default __webpack_public_path__ + "static/media/2_0044.a7b0869e.webp";